import { ProjectDto } from "common/dtos/ProjectDto";
import { RoleDto } from "common/dtos/RoleDto";
import TextButton from "components/Button/TextButton";
import Input from "components/Input";
import InputArray from "components/InputArray";
import Textarea from "components/Textarea";
import {
  ChangeEvent,
  useEffect,
  useState,
  Dispatch,
  SetStateAction,
} from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface NewRoleFormProps {
  projectData: ProjectDto;
  setProjectData: Dispatch<SetStateAction<ProjectDto>>;
}

const Wrapper = styled.div`
  width: 100%;
`;

const initialNewRoleState = {
  name: "",
  description: "",
  requirements: [],
};

const NewRoleForm = ({ setProjectData, projectData }: NewRoleFormProps) => {
  const { t } = useTranslation("project");
  const [newRole, setNewRole] = useState<RoleDto>(initialNewRoleState);

  // reset form after adding a new role
  useEffect(() => {
    setNewRole(initialNewRoleState);
  }, [projectData.roles]);

  const removeEntry = (target: string) => {
    setNewRole((prevState) => ({
      ...prevState,
      requirements: prevState.requirements.filter((entry) => entry !== target),
    }));
  };

  return (
    <Wrapper>
      <Input
        value={newRole.name}
        label={t("title")}
        placeholder={t("addTitle")}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          setNewRole((prevState) => ({
            ...prevState,
            name: e.target.value,
          }))
        }
        styles={{ margin: "24px 0" }}
      />
      <Textarea
        value={newRole.description}
        label={t("description")}
        placeholder={t("addDescription")}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          setNewRole((prevState) => ({
            ...prevState,
            description: e.target.value,
          }))
        }
        styles={{ marginBottom: "24px" }}
      />
      <InputArray
        label={t("skills")}
        placeholder={t("addSkill")}
        entries={newRole.requirements}
        addEntry={(value: string) => {
          setNewRole((prevState) => ({
            ...prevState,
            requirements: [value, ...prevState.requirements],
          }));
        }}
        removeEntry={removeEntry}
      />
      <TextButton
        label={t("addRole")}
        onClick={() => {
          setProjectData((prevState) => ({
            ...prevState,
            roles: [...prevState.roles, newRole],
          }));
        }}
        styles={{ marginTop: "24px" }}
      />
    </Wrapper>
  );
};

export default NewRoleForm;
